import axios from 'axios';

export const getContact = async (contactId) => axios.get(`${global?.AppConfig?.CLIENT_MEMBER_URL_SUFFIX}/v1.0/contacts/${contactId}/details`);

export const getPortfolioDetails = (contactId, portfolioId, language = 'de') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/contacts/${contactId}/portfolios/${portfolioId}?language=${language}`,
);

export const getModelPortfolios = async (productId, language = 'en') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/products/${productId}/model-portfolios?language=${language}`,
);
export const getModelPortfolio = async (portfolioId, language = 'en') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.2/model-portfolios/${portfolioId}?language=${language}`,
);

export const getSettings = () => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/settings`,
);

export const getAllPortfolios = (contactId, language = 'en') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/contacts/${contactId}/portfolios?language=${language}`,
);

export const getSchemaListByKey = (key) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/schemas/lists/${key}/items?useApplicationToken=true&language=de`,
);

export const getResources = (language = 'en') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/resourcesets/ClientHub?useApplicationToken=true&language=${language}`,
);

export const getSchemasListsByKey = (listKey, language = 'en') => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.1/schemas/lists/${listKey}/items?useApplicationToken=true&language=${language}`,
);

export const getFeatureFlags = (key) => axios.get(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/settings/FeatureFlags/${key}`,
);
